import { gql } from "@apollo/client";

export const CupboardFragment = gql`
  fragment CupboardFragment on Cupboard {
    id
    items {
      id
      itemId
      name
      quantity
      updatedAt
    }
  }
`;

// The organization's cupboard, empty until something is put in it. Read by
// the cupboard screen and the chat's Cupboard tab; the cache answers the
// second.
export const get = gql`
  query CupboardGet {
    viewer {
      id
      account {
        id
        cupboard {
          id
          get {
            ...CupboardFragment
          }
        }
      }
    }
  }
  ${CupboardFragment}
`;

// Each answers with the whole cupboard under the same `cupboard/<orgId>` id
// the read cached it as, so Apollo replaces it in place and every list
// follows without a refetch. So does a chat reply that changed it.
export const add = gql`
  mutation CupboardAdd($input: CupboardAddInput!) {
    viewer {
      account {
        cupboard {
          add(input: $input) {
            ...CupboardFragment
          }
        }
      }
    }
  }
  ${CupboardFragment}
`;

export const update = gql`
  mutation CupboardUpdate($input: CupboardUpdateInput!) {
    viewer {
      account {
        cupboard {
          update(input: $input) {
            ...CupboardFragment
          }
        }
      }
    }
  }
  ${CupboardFragment}
`;

export const remove = gql`
  mutation CupboardRemove($input: CupboardRemoveInput!) {
    viewer {
      account {
        cupboard {
          remove(input: $input) {
            ...CupboardFragment
          }
        }
      }
    }
  }
  ${CupboardFragment}
`;

// The add line: one item as typed, checked by Jev as food and tidied by Claude
// (spelling, amount, the same food already listed), then added or merged.
// `cupboard` lands on the cached one by its id.
export const addChecked = gql`
  mutation CupboardAddChecked($input: CupboardAddCheckedInput!) {
    viewer {
      account {
        cupboard {
          addChecked(input: $input) {
            id
            outcome
            typed
            name
            quantity
            itemId
            cupboard {
              ...CupboardFragment
            }
          }
        }
      }
    }
  }
  ${CupboardFragment}
`;
